export default {"src":"/_next/static/media/GT.fbfcef9e.svg","height":18,"width":18};